angular.module('zc.zenclerkS')
  .factory('ZcsSegment', ZcsSegment);

ZcsSegment.$inject = ['$q', '$translate', 'AccessStats', 'CampaignSegment', 'ZcsEstimator'];
function ZcsSegment($q, $translate, AccessStats, CampaignSegment, ZcsEstimator) {
  const DAYS_PER_MONTH = 30;
  const segmentData = {
    zcs_segment_all: {
      label: $translate.instant('services.segment.all.label'),
      details: $translate.instant('services.segment.all.details'),
      info: $translate.instant('services.segment.all.info'),
      icon: '/assets/img/illustration-all.svg',
      demoEstimatedMonthlyCouponRevenue: 589952,
      requiredDays: 0,
    },
    zcs_segment_new: {
      label: $translate.instant('services.segment.new.label'),
      details: $translate.instant('services.segment.new.details'),
      info: $translate.instant('services.segment.new.info'),
      icon: '/assets/img/illustration-cart-empty.svg',
      demoEstimatedMonthlyCouponRevenue: 466415,
      requiredDays: 0,
    },
    zcs_segment_one_cv: {
      label: $translate.instant('services.segment.oneCv.label'),
      details: $translate.instant('services.segment.oneCv.details'),
      info: $translate.instant('services.segment.oneCv.info'),
      demoEstimatedMonthlyCouponRevenue: 93537,
      requiredDays: 30,
    },
    zcs_segment_cv_users: {
      label: $translate.instant('services.segment.cvUsers.label'),
      details: $translate.instant('services.segment.cvUsers.details'),
      info: $translate.instant('services.segment.cvUsers.info'),
      icon: '/assets/img/illustration-cart-ok.svg',
      demoEstimatedMonthlyCouponRevenue: 123537,
      requiredDays: 30,
    },
    zcs_segment_loyal: {
      label: $translate.instant('services.segment.loyal.label'),
      details: $translate.instant('services.segment.loyal.details'),
      info: $translate.instant('services.segment.loyal.info'),
      demoEstimatedMonthlyCouponRevenue: 30138,
      requiredDays: 60,
    },
    /*zcs_segment_all_except_loyal: {
      label: 'Except Loyal',
      details: '',
      demoEstimatedMonthlyCouponRevenue: 423536,
      requiredDays: 60,
    },
    zcs_segment_dormant: {
      label: 'Dormant',
      details: 'Purchased it in the past, but I have not purchased it within 60 days',
      demoEstimatedMonthlyCouponRevenue: 29139,
      requiredDays: 60,
    },*/
    zcs_segment_mail_only: {
      label: $translate.instant('services.segment.mailOnly.label'),
      details: $translate.instant('services.segment.mailOnly.details'),
      info: $translate.instant('services.segment.mailOnly.info'),
      icon: '/assets/img/illustration-mail.svg',
      demoEstimatedMonthlyCouponRevenue: 0,
      requiredDays: 0,
      disableEstimate: true
    }
  };

  return {
    get,
    all,
    convertToProposal,
    getSegmentLabel,
    getSegmentIcon,
    getSegmentInfo,
    getProposals,
    getLatestStatsForSegment,
    segmentData
  };

  // TODO: use segment instead of name
  function getSegmentLabel(name) {
    if(!segmentData[name]) return '';

    return segmentData[name].label;
  }

  function getSegmentIcon(segment) {
    // TODO: return missing or something
    if(!segment || !segment.name) {
      return '';
    }

    return segmentData[segment.name].icon;
  }

  function getSegmentInfo(segment) {
    // TODO: return missing or something
    if(!segment || !segment.name) {
      return '';
    }

    return segmentData[segment.name].info;
  }

  function getSegmentClass(segment) {
    if(!segment || !segment.name) {
      return '';
    }
    return segment.name.replace(/_/g, '-');
  }

  function convertToProposal(segment) {
    const proposal = {};
    proposal.class = getSegmentClass(segment);
    proposal.name = segment.name;
    proposal.segment = segment;
    proposal.segment_id = segment.id;
    proposal.label = getSegmentLabel(segment.name);
    proposal.icon = getSegmentIcon(segment);
    proposal.info = getSegmentInfo(segment);
    proposal.disableEstimate = segmentData[segment.name].disableEstimate;
    return proposal;
  }

  function generateDemoData(proposal) {
    const estimatedMonthlyCouponRevenue = segmentData[proposal.name].demoEstimatedMonthlyCouponRevenue;
    proposal.stats = { estimatedMonthlyCouponRevenue };
  }

  function getProposals(project) {
    // Use $q because we do processing to existing in promises,
    // so this is simplest way.
    // It is necessary to return a resolved result to avoid UI flickering
    // because of asynchronous requests.
    return $q((resolve, reject) => {
      all(project.apikey)
        .then(segments => {
          const proposals = _.map(segments, convertToProposal);
          // for demo
          if(project.is_demo) {
            _.each(proposals, generateDemoData);
            resolve(proposals);
          } else {
            const promises = _.map(proposals, proposal => {
              const promise = ZcsEstimator.getEstimatedMonthlyStatsForSegment(project, proposal.segment)
                .then(res => {
                  proposal.stats = res;
                  return proposal;
                });
              return promise;
            });

            $q.all(promises)
              .then(resolvedProposals => {
                // disable all_except_loyal if loyal's stats are 0
                const loyalSegment = _.find(proposals, p => p.name === 'zcs_segment_loyal');
                if(loyalSegment && loyalSegment.stats && loyalSegment.stats.estimatedMonthlyCouponRevenue === 0) {
                  const disableSegments = ['zcs_segment_loyal', 'zcs_segment_all_except_loyal'];
                  resolvedProposals = _.reject(resolvedProposals, p => disableSegments.indexOf(p.name) >= 0);
                }

                resolve(resolvedProposals);
              });
          }
        });
    });
  }

  function getLatestStatsForSegment(segmentId, apikey) {
    return AccessStats.find({
      dimension: 'daily',
      apikey: apikey,
    }, {
      match: {
        campaign_segment_id: segmentId,
        is_control: null,
        device: null,
        start_at: {
          // ignore today and take latest
          $gte: moment().subtract(4, 'days').toDate(),
          $lte: moment().subtract(1, 'days').toDate(),
        }
      },
      sort: {
        start_at: -1
      },
      limit: 1
    }).then(results => {
      _.each(results, stats => {
        stats.average_conversion_price = stats.conversion_price / stats.conversion_count;

        stats.estimated_monthly_conversion_price = stats.conversion_price * DAYS_PER_MONTH * 0.34;
      });
      return results;
    });
  }

  function get(projectId, segmentId) {
    return CampaignSegment.get(projectId, segmentId);
  }

  function all(apikey) {
    return CampaignSegment.all(`apikey:${apikey}`).then(res => {
      const segments = res;
      // TODO: filter out also those who didn't have any matches
      return _.chain(segments)
        .filter(d => d.name.indexOf('zcs_segment') === 0)
        .reject(d => !segmentData[d.name])
        .value();
    });
  }

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/segment.service.js